export default __webpack_public_path__ + "static/media/数据可视化.7ed54a00.jpg";